<div class="d-flex justify-content-center text-center align-items-center flex-column {{size}} h-100">
  <img src="assets/images/notfound.svg" alt="">
  <div class="not-found mt-2">{{title}}</div>
  <div class="not-found mt-4">{{subtitle}}</div>
</div>
